import 'maz-ui/lib/css/base.css';
import 'maz-ui/lib/css/maz-input.css';
import 'maz-ui/lib/css/maz-phone-number-input.css';
import { MazPhoneNumberInput } from 'maz-ui';
import { defineComponent, ref, computed } from 'vue';
import { useBrowserWidth } from '../../../composables/browser.js';
import '@caresend/utils';
import 'lodash.isequal';
import '../../../router/helpers/initRouter.js';
import '@caresend/types';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../specific/portal/store/portal/sessionStore.js';
import 'file-saver';
import '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/encryption/model.js';
import 'js-sha256';
import 'lodash.clonedeep';
import '../../specific/portal/store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import '../../../database/firebaseConfig/methods.js';
import '../../ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'immutability-helper';
import '../../../router/routes/dev/model.js';
import '../../../router/routes/dev/routes.js';
import '../../../router/routes/dashboard/model.js';
import '../../../router/routes/pro/model.js';
import '../../../router/routes/visitsPage/model.js';
import '../../../router/routes/orderFlow/model.js';
import '../../../router/routes/orderFlow/privateHelpers.js';
import '../../../router/routes/orderFlow/routes.js';
import '../../../router/routes/schedulingFlow/model.js';
import '../../../router/routes/schedulingFlow/routes.js';
import '../../../router/routes/chartingFlow/model.js';
import '../../../router/routes/chartingFlow/routes.js';
import '../../../router/routes/portal/portalRoutes.js';
import '../../../router/routes/portal/model.js';
import '../../../router/routes/visitsPage/routes.js';
import { isExactTheme } from '../../../store/modules/app/helpers.js';
import '../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../store/modules/chartingFlow/model.js';
import '../../../store/modules/office/index.js';
import '../../specific/VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../store/modules/office/model.js';
import '../../../store/modules/orderFlow/index.js';
import '../../../store/modules/procedures/model.js';
import '../../../store/modules/schedulingFlow/index.js';
import '../../../store/modules/schedulingFlow/model.js';
import '../../specific/dev/AdvancedSettings/subViews/FeatureFlags/model.js';

var script = defineComponent({
    name: 'PhoneNumberInput',
    components: {
        MazPhoneNumberInput,
    },
    props: {
        boldLabel: Boolean,
        countryCode: {
            type: String,
            default: 'US',
        },
        disabled: Boolean,
        label: {
            type: String,
            default: null,
        },
        phoneNumber: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: 'Phone number',
        },
        size: {
            type: String,
            default: 'md',
        },
        smallLabel: Boolean,
    },
    emits: {
        update: (_event) => true,
        validated: (_event) => true,
    },
    setup(props, { emit }) {
        const hasNumber = ref(false);
        const numberIsValid = ref(false);
        const isInvalid = computed(() => hasNumber.value && !numberIsValid.value);
        const classNames = computed(() => {
            const names = [];
            switch (props.size) {
                case 'sm':
                    names.push('PhoneNumberInput--sm');
                    break;
                case 'md':
                    names.push('PhoneNumberInput--md');
            }
            if (props.boldLabel)
                names.push('PhoneNumberInput--bold-label');
            if (props.smallLabel)
                names.push('PhoneNumberInput--small-label');
            if (isInvalid.value)
                names.push('PhoneNumberInput--is-invalid');
            if (props.disabled)
                names.push('PhoneNumberInput--disabled');
            return names;
        });
        const computedPlaceholder = computed(() => isExactTheme()
            ? '( _ _ _ ) - _ _ _ - _ _ _ _'
            : props.placeholder);
        const { isMobile } = useBrowserWidth();
        const translations = computed(() => ({
            countrySelectorLabel: isMobile.value ? 'Country' : 'Country code',
        }));
        const handleUpdate = (phoneNumberInfo) => {
            const { countryCallingCode, countryCode, isValid, nationalNumber, phoneNumber, } = phoneNumberInfo;
            numberIsValid.value = isValid;
            hasNumber.value = !!phoneNumber;
            const updatedNumber = {
                phone: {
                    countryCode,
                    callingCode: countryCallingCode ? `+${countryCallingCode}` : '',
                    number: `${nationalNumber !== null && nationalNumber !== void 0 ? nationalNumber : ''}`,
                },
                isValid,
            };
            emit('update', updatedNumber);
            if (isValid) {
                emit('validated', updatedNumber);
            }
        };
        return {
            classNames,
            color: '#c3c6c9',
            computedPlaceholder,
            handleUpdate,
            translations,
        };
    },
});

export { script as default };
